export default "http://api.exhibition.vsteach.com"



// WEBPACK FOOTER //
// ./src/utils/Url.js